<template>

    <div id="banner">

        <div
            v-if="banners.length"
            class="carousel"
    
            @mouseenter="stopAutoplay"
            @mouseleave="startAutoplay"
        >
            <transition name="banner-fade" mode="out-in">
                <img
                    :key="banners[currentIndex].imgUrl"
                    class="banner-image"
                    :src="getImageSrc(banners[currentIndex].imgUrl)"
                    :alt="banners[currentIndex].alt"
                />
            </transition>
        </div>

        <button
            v-if="banners.length > 1"
            type="button"
            class="carousel-control previous"
            @click.stop="showPrevious"
        >
            <span aria-hidden="true">&lt;</span>
            <span class="sr-only">Previous banner</span>
        </button>

        <button
            v-if="banners.length > 1"
            type="button"
            class="carousel-control next"
            @click.stop="showNext"
        >
            <span aria-hidden="true">&gt;</span>
            <span class="sr-only">Next banner</span>
        </button>

        <div v-if="banners.length > 1" class="carousel-dots">
            <button
                v-for="(banner, index) in banners"
                :key="`carousel-dot-${index}`"
                type="button"
                class="dot"
                :class="{ active: index === currentIndex }"
                @click.stop="goToSlide(index)"
            >
                <span class="sr-only">Go to banner {{ index + 1 }}</span>
            </button>
        </div>

    </div>

</template>

<script>

export default {
    name: 'Banner',
    data() {
        return {
            currentIndex: 0,
            banners: [
                {
                    imgUrl: 'banner_2.png',
                    alt: "Reena's Jade Massage Therapy seasonal promotions banner"
                },
                {
                    imgUrl: 'banner.png',
                    alt: "Reena's Jade Massage Therapy banner"
                }
            ],
            autoplayDelay: 3000,
            intervalId: null
        }
    },
    mounted() {
        this.startAutoplay()
    },
    beforeDestroy() {
        this.stopAutoplay()
    },
    methods: {
        goToOffers() {
            this.$router.replace('/offers')
        },
        getImageSrc(fileName) {
            return require(`@/assets/images/${fileName}`)
        },
        showNext() {
            this.currentIndex = (this.currentIndex + 1) % this.banners.length
            this.resetAutoplay()
        },
        showPrevious() {
            this.currentIndex = (this.currentIndex - 1 + this.banners.length) % this.banners.length
            this.resetAutoplay()
        },
        goToSlide(index) {
            this.currentIndex = index
            this.resetAutoplay()
        },
        startAutoplay() {
            if (this.intervalId || this.banners.length <= 1) {
                return
            }
            this.intervalId = setInterval(() => {
                this.showNext()
            }, this.autoplayDelay)
        },
        stopAutoplay() {
            if (!this.intervalId) {
                return
            }
            clearInterval(this.intervalId)
            this.intervalId = null
        },
        resetAutoplay() {
            this.stopAutoplay()
            this.startAutoplay()
        }
    }
}


</script>

<style scoped>

#banner {
    width: 100%;
    max-width: 1200px;
    margin: auto;
    position: relative;
    z-index: 1;
    margin-top: 100px;
    box-sizing: border-box;
    height: auto;
    max-height: 1024px;
}

.carousel {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.35);
    border: none;
    color: #ffffff;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 3;
}

.carousel-control.previous {
    left: 16px;
}

.carousel-control.next {
    right: 16px;
}

.carousel-control:focus {
    outline: 2px solid #ffffff;
}

.carousel-dots {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 3;
}

.dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: none;
    background-color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    padding: 0;
}

.dot.active {
    background-color: rgba(255, 255, 255, 0.9);
}

.banner-fade-enter-active,
.banner-fade-leave-active {
    transition: opacity 0.5s ease;
}

.banner-fade-enter,
.banner-fade-leave-to {
    opacity: 0;
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}

@media(max-width: 750px) {
    #banner {
        margin-top: 50px;
    }
}

</style>